import { ReactNode, useState } from 'react';
import { createPortal } from 'react-dom';

import { useContextualSurface } from 'approot/shared/ally/contextual.hooks';
import IconQuestionMark from 'approot/shared/icons/icon-question-mark';
import { ImagePicture } from 'approot/shared/images/images';
import * as Styled from './more-information-tooltip.style';

import moreInfoPng from './more-information.png';
import moreInfoAvif from './more-information.avif';
import moreInfoWebp from './more-information.webp';

export const MoreInformationCheckAnswerTooltip = () => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const { styles, attributes, setReferenceElement, setPopperElement } =
    useContextualSurface(isActive, () => setIsActive(false), {
      placement: 'top',
    });

  return (
    <>
      {isActive &&
        createPortal(
          <Styled.MoreInfoTooltip
            ref={setPopperElement}
            role="dialog"
            tabIndex={-1}
            style={styles.popper}
            {...attributes.popper}
          >
            <figure>
              <ImagePicture
                avif={{ path: moreInfoAvif }}
                webp={{ path: moreInfoWebp }}
                png={{ path: moreInfoPng }}
              />
            </figure>
            <figcaption>
              Use this to teach your students further, explaining the correct
              answer. It will appear when checking the answers.
            </figcaption>
          </Styled.MoreInfoTooltip>,
          document.body
        )}

      <Styled.MoreInfoButton
        type="button"
        ref={setReferenceElement}
        onClick={() => setIsActive(!isActive)}
        onMouseEnter={() => setIsActive(true)}
        onMouseLeave={() => setIsActive(false)}
      >
        <IconQuestionMark width={16} height={16} />
      </Styled.MoreInfoButton>
    </>
  );
};

export const MoreInfo = ({ children }: { children: ReactNode }) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const { styles, attributes, setReferenceElement, setPopperElement } =
    useContextualSurface(isActive, () => setIsActive(false), {
      placement: 'top',
    });

  return (
    <>
      {isActive &&
        createPortal(
          <Styled.MoreInfoTooltipContent
            ref={setPopperElement}
            role="dialog"
            tabIndex={-1}
            style={styles.popper}
            {...attributes.popper}
          >
            {children}
          </Styled.MoreInfoTooltipContent>,
          document.body
        )}

      <Styled.MoreInfoButton
        type="button"
        ref={setReferenceElement}
        onClick={() => setIsActive(!isActive)}
        onMouseEnter={() => setIsActive(true)}
        onMouseLeave={() => setIsActive(false)}
      >
        <IconQuestionMark width={16} height={16} />
      </Styled.MoreInfoButton>
    </>
  );
};
